import React from 'react';

/**
 * BubbleStatusIcon — renders the correct tick/clock SVG for a message status.
 *
 * tickColor is always rendered on top of the sender bubble, so we override
 * it with black to guarantee visibility regardless of the bubble's fill colour.
 */
const BubbleStatusIcon = ({ status, tickColor }) => {
  // The tick always sits on the sender bubble. Force black so it's always visible.
  const color = '#000000';
  const mutedColor = 'rgba(0,0,0,0.6)';

  if (status === 'read') {
    return (
      <svg width="16" height="11" viewBox="0 0 16 11" fill="none">
        <path d="M11.071 0.5L5.91 5.661L4.339 4.089L3.25 5.178L5.91 7.839L12.161 1.589L11.071 0.5Z" fill={color} />
        <path d="M15.589 1.589L14.5 0.5L8.339 6.661L9.429 7.75L15.589 1.589Z" fill={color} />
        <path d="M7.25 7.75L8.339 8.839L9.429 7.75L8.339 6.661L7.25 7.75Z" fill={color} />
      </svg>
    );
  }
  if (status === 'sent' || status === 'delivered') {
    return (
      <svg width="16" height="11" viewBox="0 0 16 11" fill="none">
        <path d="M11.071 0.5L5.91 5.661L4.339 4.089L3.25 5.178L5.91 7.839L12.161 1.589L11.071 0.5Z" fill={mutedColor} />
        <path d="M15.589 1.589L14.5 0.5L8.339 6.661L9.429 7.75L15.589 1.589Z" fill={mutedColor} />
        <path d="M7.25 7.75L8.339 8.839L9.429 7.75L8.339 6.661L7.25 7.75Z" fill={mutedColor} />
      </svg>
    );
  }
  if (status === 'pending') {
    return (
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
        <circle cx="6" cy="6" r="5" stroke={mutedColor} strokeWidth="1.5" />
        <path d="M6 3V6L8 8" stroke={mutedColor} strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }
  // Default single tick
  return (
    <svg width="12" height="9" viewBox="0 0 12 9" fill="none">
      <path d="M1 4L4.5 7.5L11 1" stroke={mutedColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default BubbleStatusIcon;
